module.exports = __webpack_public_path__ + "img/farming-by-numbers--pig.0bb05c12.png";